import React, { useState } from "react";
import { Entry, nameTaken } from "./ranking";

const MAX_NAME_LENGTH = 12;
const KEY_ROWS = ["1234567890", "QWERTYUIOP", "ASDFGHJKL", "ZXCVBNM"];

interface NameRegistrationProps {
  entries: Entry[];
  onStart: (name: string) => void;
}

// "Vamos jogar?" screen (mockup 3): on-screen keyboard, one play per name.
export default function NameRegistration({ entries, onStart }: NameRegistrationProps) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const typeKey = (key: string) => {
    setError("");
    setName((current) => (current.length >= MAX_NAME_LENGTH ? current : current + key));
  };

  const deleteKey = () => {
    setError("");
    setName((current) => current.slice(0, -1));
  };

  const start = () => {
    const cleanName = name.trim().replace(/\s+/g, " ");
    if (!cleanName) return setError("Escreve o teu nome");
    if (nameTaken(entries, cleanName)) return setError("Nome já utilizado");
    onStart(cleanName);
  };

  return (
    <main className="ad-screen ad-register">
      <h1 className="ad-banner">Vamos jogar?</h1>
      <div className={`ad-name ${name ? "" : "empty"}`}>{name || "Coloca aqui o teu nome"}</div>
      <div className="ad-error" aria-live="polite">
        {error}
      </div>
      <div className="ad-keyboard">
        {KEY_ROWS.map((row) => (
          <div key={row} className="ad-keyboard-row">
            {row.split("").map((key) => (
              <button key={key} className="ad-key" onPointerDown={() => typeKey(key)}>
                {key}
              </button>
            ))}
          </div>
        ))}
        <div className="ad-keyboard-row">
          <button className="ad-key wide" onPointerDown={() => typeKey(" ")}>
            Espaço
          </button>
          <button className="ad-key" onPointerDown={deleteKey} aria-label="Apagar">
            ⌫
          </button>
        </div>
      </div>
      <button type="button" className="ad-pill" onClick={start}>
        Começar
      </button>
    </main>
  );
}
